var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 35.29,
    x2: 8.482,
    y1: 12.906,
    y2: 39.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60affe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#6ab4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#97cbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#bddeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#daecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#eef7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M26.926,5.5H12.541c-1.679,0-3.041,1.343-3.041,3v31c0,1.657,1.361,3,3.041,3h23.311 c1.679,0,3.041-1.343,3.041-3V17.307c0-0.516-0.208-1.012-0.578-1.377L28.321,6.07C27.951,5.705,27.449,5.5,26.926,5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M32.404,42.5H35.5c1.657,0,3-1.343,3-3v-23h-8c-1.657,0-3-1.343-3-3v-1.457"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M9.5,18.213V39.5c0,1.657,1.343,3,3,3h14.734"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M38.5,16.5l-11-11h-15c-1.657,0-3,1.343-3,3v3.904"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e9bfe",
    d: "M16.49,25c-0.1,0-0.2-0.01-0.29-0.03c-0.1-0.02-0.19-0.05-0.28-0.08c-0.09-0.04-0.18-0.09-0.26-0.14 c-0.09-0.06-0.16-0.12-0.23-0.19c-0.28-0.28-0.44-0.67-0.44-1.06c0-0.39,0.16-0.78,0.44-1.06c0.35-0.35,0.87-0.51,1.35-0.41 c0.1,0.02,0.19,0.05,0.28,0.08c0.09,0.04,0.18,0.09,0.26,0.14c0.08,0.06,0.16,0.12,0.23,0.19c0.28,0.28,0.44,0.67,0.44,1.06 c0,0.39-0.16,0.78-0.44,1.06c-0.07,0.07-0.15,0.13-0.23,0.19c-0.08,0.05-0.17,0.1-0.26,0.14c-0.09,0.03-0.18,0.06-0.28,0.08 C16.69,24.99,16.59,25,16.49,25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e9bfe",
    d: "M16.49,31c-0.4,0-0.78-0.16-1.06-0.44c-0.28-0.28-0.44-0.66-0.44-1.06c0-0.39,0.16-0.78,0.44-1.06 c0.07-0.07,0.14-0.13,0.23-0.19c0.08-0.05,0.16-0.1,0.26-0.13c0.09-0.04,0.18-0.07,0.28-0.09c0.19-0.04,0.39-0.04,0.58,0 c0.1,0.02,0.19,0.05,0.28,0.09c0.09,0.03,0.18,0.08,0.26,0.13c0.08,0.06,0.16,0.12,0.23,0.19c0.07,0.07,0.13,0.15,0.19,0.23 c0.05,0.08,0.1,0.17,0.13,0.26c0.04,0.09,0.07,0.18,0.09,0.28c0.02,0.09,0.03,0.19,0.03,0.29c0,0.4-0.16,0.78-0.44,1.06 C17.27,30.84,16.88,31,16.49,31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e9bfe",
    d: "M16.49,37c-0.4,0-0.78-0.16-1.06-0.44c-0.28-0.28-0.44-0.66-0.44-1.06c0-0.4,0.16-0.78,0.44-1.06 c0.35-0.35,0.86-0.51,1.35-0.41c0.1,0.02,0.19,0.05,0.28,0.09c0.09,0.03,0.18,0.08,0.26,0.13c0.08,0.06,0.16,0.12,0.23,0.19 c0.28,0.28,0.44,0.67,0.44,1.06c0,0.39-0.16,0.78-0.44,1.06c-0.07,0.07-0.15,0.13-0.23,0.19c-0.08,0.05-0.17,0.1-0.26,0.13 c-0.09,0.04-0.18,0.07-0.28,0.09C16.69,36.99,16.59,37,16.49,37z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.383,
    x2: 31.511,
    y1: 23.5,
    y2: 23.5,
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.383,
    x2: 31.511,
    y1: 29.5,
    y2: 29.5,
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.383,
    x2: 31.511,
    y1: 35.5,
    y2: 35.5,
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.59020a71a5b2e6d1506c6898e8df612b.svg";
export { ForwardRef as ReactComponent };